export default "__VITE_ASSET__DYcND6Q5__"